/**
 *Angular module*/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
/**
 *Pipe*/
import * as moment from 'moment';
/**
 *Shared*/
import {Utils} from '../../utils';
import {MatSelectChange} from '@angular/material';
import {TitleCasePipe} from '@angular/common';

@Component({
    selector: 'app-data-table-filter',
    templateUrl: './data-table-filter.component.html',
    styleUrls: ['./data-table-filter.component.scss'],
    providers: [TitleCasePipe]
})
export class DataTableFilterComponent implements OnInit {
    @Output() taskChange: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Data object to search from filter*
     */
    @Input() data: Object;
    @Input() disableAdd = false;

    @Input() filters: any;
    @Input() subFilterArray: any;

    @Input() searchValue = '';
    public searchField: any = '';

    @Input() enableDatePicker = false;
    showDatePicker = false;
    filterArray: Array<any>;
    resultArray: Array<any>;
    filterParameters: any;
    multipleFilterList: any;
    groupArray = [
        {label: 'Text', data: []},
        {label: 'Single selection', data: []},
        {label: 'Multiple selection', data: []},
        {label: 'Date', data: []},
        {label: 'Date with range', data: []},
    ];
    tempSelectedOption: any;

    /**
     * Date variables*
     */
    searchFrom;
    searchTo;

    /**
     * Check device types*
     */
    public isLaptop: boolean;
    public isMobile: boolean;

    expandStatus = false;
    selectedValue;

    constructor(public titleCasePipe: TitleCasePipe) {
        this.searchFrom = {year: moment().get('year'), month: moment().get('month'), day: moment().get('date') + 1};
        this.searchTo = {year: moment().get('year'), month: moment().get('month') + 1, day: moment().get('date') + 1};
        this.isLaptop = Utils.isLaptop();
        this.isMobile = Utils.isMobile();
        this.resultArray = [];
    }

    ngOnInit() {
        this.showDatePicker = this.enableDatePicker;
        this.loadData();
    }

    loadData() {
        this.subFilterArray.forEach((item: any) => {
            switch (item.type) {
                case 'text':
                    this.groupArray[0]['data'].push(item);
                    break;
                case 'list':
                    this.groupArray[1]['data'].push(item);
                    break;
                case 'list-multiple':
                    this.groupArray[2]['data'].push(item);
                    this.formatArrayForMultiple(item.id, this.data[item.id]);
                    break;
                case 'date':
                    this.groupArray[3]['data'].push(item);
                    break;
                case 'date-range':
                    this.groupArray[4]['data'].push(item);
                    break;
            }
            this.resultArray.push({[item.id]: []});
        });
    }

    checkLength(group: any) {
        return group.length > 0;
    }

    pushArray(matSelectChange: MatSelectChange) {

        this.filterArray = this.selectedValue;

        const isField = matSelectChange.value.find((x) => x.id == this.tempSelectedOption);
        if (isField != undefined) {
            if (isField.type == 'date') {
                this.pushDate(moment().set({
                    'year': this.searchFrom.year,
                    'month': this.searchFrom.month,
                    'date': this.searchFrom.day
                }).format('YYYY-MM-DD'), isField.id);
            }
        } else {
            this.removeFilter(this.tempSelectedOption);
        }

        this.expandStatus = true;

        if (this.filterArray.length <= 0) {
            this.expandStatus = false;
            this.selectedValue = undefined;
        }
    }

    pushText(value: any, field: string) {
        this.resultArray.forEach((item: any) => {
            if (item[field] != undefined) {
                item[field] = [value.target.value];
            }
        });
        this.expandStatus = true;
        // this.onSubmit();
    }

    pushDate(value: any, field: string) {
        this.resultArray.forEach((item: any) => {
            if (item[field] != undefined) {
                item[field] = [value];
            }
        });
        this.expandStatus = true;
        this.onSubmit();
    }

    pushResult(field: string, matSelectChange: MatSelectChange) {
        this.resultArray.forEach((item: any) => {
            if (item[field] != undefined) {
                if (this.subFilterArray.find((x: any) => x.id == field && x.type == 'list-multiple')) {
                    item[field].push(matSelectChange.value);
                } else {
                    item[field] = [matSelectChange.value];
                }
            }
        });
        this.onSubmit();
    }

    formatArrayForMultiple(field: string, array: Array<any>) {
        this.multipleFilterList = {
            [field]: [
                {
                    id: 1,
                    name: this.titleCasePipe.transform(field.replace('_', ' ')),
                    variant: array.map((item: any) => {
                        item['parent_id'] = 1;
                        item['value'] = item['name'];
                        return item;
                    })
                }
            ]
        };
    }

    removeFilter(field: string) {
        this.filterArray = this.filterArray.filter((item: any) => field != item.id);
        this.selectedValue = this.filterArray;
        this.resultArray.forEach((item: any) => {
            if (item[field] != undefined) {
                item[field] = [];
            }
        });
        if (this.filterArray.length <= 0) {
            this.expandStatus = false;
            this.selectedValue = undefined;
        }
        this.onSubmit();
    }

    /*
        isFilterApplied() {
            const filterToSearch = this.subFilterArray.slice(1);
            let emptyFilterCount = filterToSearch.length;
            filterToSearch.forEach((item: any) => {
                this.resultArray.forEach((result: any) => {
                    if (result[item.id] != undefined) {
                        if (result[item.id].length == 0) {
                            emptyFilterCount = emptyFilterCount - 1;
                        }
                    }
                });
            });
            return emptyFilterCount != 0;
        }

        getObjectKey(object: any) {
            return object[Object.keys(object)[0]];
        }
    */

    public getSelectedFilter(field: string, taskOperation: any): void {
        const multipleValues = <Array<any>>taskOperation[1]['value'];

        this.resultArray.forEach((item: any) => {
            if (item[field] != undefined) {
                item[field] = [];
                multipleValues.forEach((multipleValue: any) => item[field].push(multipleValue));
            }
        });
        this.onSubmit();
    }

    onSubmit() {
        this.filterParameters = {};
        const filterToSearch = this.subFilterArray.slice(1);
        filterToSearch.forEach((item: any) => {
            this.filterParameters[item.id] = '';
        });

        if (this.enableDatePicker && this.showDatePicker) {
            this.filterParameters = {
                ...this.filterParameters,
                search_from: moment().set({
                    'year': this.searchFrom.year,
                    'month': this.searchFrom.month - 1,
                    'date': this.searchFrom.day
                }).format('YYYY-MM-DD'),
                search_to: moment().set({
                    'year': this.searchTo.year,
                    'month': this.searchTo.month - 1,
                    'date': this.searchTo.day
                }).format('YYYY-MM-DD')
            };
        }

        filterToSearch.forEach((item: any) => {
            this.resultArray.forEach((result: any) => {
                if (result[item.id] != undefined) {
                    if (result[item.id].length != 0) {
                        const isMultiple = this.filterArray.find((x: any) => x.id == item.id && item.type == 'list-multiple');
                        if (isMultiple != undefined) {
                            this.filterParameters = {
                                ...this.filterParameters,
                                [item.id]: result[item.id]
                            };
                        } else if (item.type == 'text' || item.type == 'date' || item.type == 'date-range') {
                            this.filterParameters = {
                                ...this.filterParameters,
                                [item.id]: result[item.id][0]
                            };
                        } else {
                            this.filterParameters = {
                                ...this.filterParameters,
                                [item.id]: result[item.id][0]['id'].toString()
                            };
                        }
                    }
                }
            });
        });
        this.taskChange.emit(this.filterParameters);
    }
}
